import React from 'react';
import { Col, Row } from 'react-bootstrap';
import RecentJobs from '../components/home/RecentJobs';
import Benefits from './Benefits';

function HomePage() {
  return (
    <div>
      <Row>
        <Col>
          <RecentJobs />
          <Benefits />
        </Col>
      </Row>
    </div>
  );
}

export default HomePage;